
export const rolesCadastradas = {
  'requerer-compensacao-rgps': 'INSS@PAPEL_ANALISTA_RGPS',
  'analisar-compensacao-rgps': 'INSS@PAPEL_ANALISTA_RGPS',
  'analisar-compensacao-rpps': 'CNPJ@PAPEL_ANALISTA_RPPS',
  'requerer-compensacao-rpps': 'CNPJ@PAPEL_ANALISTA_RPPS',
  'fornecer-parecer-medico-rgps': 'INSS@PAPEL_MEDICO_PERITO_RGPS',
  'fornecer-parecer-medico-rpps': 'CNPJ@PAPEL_MEDICO_PERITO_RPPS',
  'analisar-negocio-sprev': 'MPS@PAPEL_ANALISTA_SPREV',
  'gerenciar-negocio-dcomp': 'INSS@PAPEL_GESTOR_DCOMP',
  'consultar-compensacao-rpps': 'CNPJ@PAPEL_RPPS_CONSULTA',
  'consultar-compensacao-rgps': 'INSS@PAPEL_RGPS_CONSULTA',
  'auditar-comprev': 'MPS@PAPEL_AUDITOR',
  'analisar-negocio-dtpv': 'DATAPREV@PAPEL_ANALISTA_DATAPREV',
  'analisar-contrato-dtpv': 'DATAPREV@PAPEL_CONTRATO_ANALISTA_DTP',
};

export const getPermissions = permissionsAllowed => (
  permissionsAllowed.map(permission => rolesCadastradas[permission])
);

export const tiposExigenciaSistema = [1, 5, 6, 17, 38, 39, 40, 41, 72];

export const estadosParaConsulta = {
  // Em exigencia: 2
  exigencia: {
    acao: 'cumprir-exigencia',
    campoOrdenacao: 'prazo-atendimento-exigencia',
    estados: [2],
    tipoParticipacao: 1,
  },
  // Em exigencia: 2 com risco de prescricao
  'prescricao-exigencia': {
    acao: 'cumprir-exigencia',
    campoOrdenacao: 'prazo-prescricao',
    estados: [2],
    tipoParticipacao: 1,
  },
  // Aguardando analise: 4, Em analise: 6, Analise Suspensa: 10
  analise: {
    acao: 'realizar-analise',
    campoOrdenacao: 'data-disponibilizacao-analise',
    estados: [4, 6, 10],
    tipoParticipacao: 2,
  },
  // Aguardando analise: 5, Em analise: 7
  'parecer-medico': {
    acao: 'emitir-parecer-medico',
    estados: [5, 7],
    tipoParticipacao: 1,
  },
  /* Em compensação: 11 */
  'cessacao-requerimento': {
    acao: 'cessar-requerimento',
    estados: [11],
    tipoParticipacao: 1,
  },
  indeferido: {
    acao: 'indeferidos',
    estados: [15],
    tipoParticipacao: 1,
  },
  'complementar-aposentadoria': {
    acao: 'complementar-aposentadoria',
    // campoOrdenacao: 'data-disponibilizacao-analise',
    estado: 4,
    tipoParticipacao: 1, // solicitante
    tipoRequerimento: 1,
  },
};

export const msgsConfirmacao = {
  indeferimento: {
    descricao: 'O Novo COMPREV possibilita a criação de exigências para correção do requerimento sem a necessidade de indeferi-lo. Confirma o indeferimento deste requerimento?',
  },
};

export const msgsConfirmacaoEnte = {
  rppsNaoEncontradoParaOEnte: {
    descricao: 'Não existe regime próprio cadastrado para o ente escolhido. Deseja incluir um regime próprio?',
  },
};

export const msgsconfirmacaoFechamentoPagamento = {
  confirmacaoFechamentoPagamento: {
    descricao: 'Confirma o fechamento do pagamento desta competência?',
  },
};

export const msgsConfirmacaoBloqueio = {
  bloqueio: {
    descricao: 'Confirma o Bloqueio do Ente Federativo?',
  },
};

export const msgsConfirmacaoDesbloqueio = {
  desbloqueio: {
    descricao: 'Confirma o desbloqueio do Ente Federativo?',
  },
};

export const msgsConfirmacaoCessacao = {
  cessacaoAposentadoria: {
    descricao: 'Confirma a cessação do requerimento de aposentadoria?',
  },
  cessacaoPensao: {
    descricao: 'Confirma a cessação do requerimento de pensão?',
  },
  cessacaoDependente: {
    descricao: 'Confirma a cessação do dependente?',
  },
  cessacaoAmbos: {
    descricao: 'Confirma a cessação do requerimento de pensão juntamente com o dependente?',
  },
};

export const msgsGlosaDeDacaoManual = {
  glosadeDacao: {
    descricao: 'Confirma inclusão de glosa manual para o ente federativo?',
  },
  removerGlosadeDacao: {
    descricao: 'Confirma exclusão da glosa para este Ente Federativo?',
  },
  alterarGlosadeDacao: {
    descricao: 'Confirma a alteração da glosa?',
  },
};

export const estadosRequerimento = {
  CRIADO: 1,
  EM_EXIGENCIA: 2,
  ALTERADO: 3,
  AGUARDANDO_ANALISE: 4,
  AGUARDANDO_ANALISE_MEDICO: 5,
  EM_ANALISE: 6,
  EM_ANALISE_MEDICO: 7,
  DEFERIDO: 8,
  INDEFERIDO: 9,
  ANALISE_SUSPENSA: 10,
  EM_COMPENSACAO: 11,
  COMPENSADO: 12,
  AGUARDANDO_COMPENSACAO_APOSENTADORIA: 13,
  REJEITADO: 14,
  EXIGENCIA_INDEFERIDO: 15,
  INDEFERIDO_RATIFICADO: 16,
  CRIADO_REJEITADO: 17,
  EM_CONFLITO_PERIODO: 18,
};

export const tamanhoMaximoArquivoUpload = 3145728;

export const orgaoAtivo = 'Ativo';
export const orgaoCentralizador = 'Centralizador';
export const orgaoExtinto = 'Extinto';
export const orgaoAtivoCentralizado = 'Ativo Centralizado';

export const alertaPesquisarDadosPessoais = [{ descricao: 'Obrigatório clicar no botão "Pesquisar" para atualizar os dados cadastrais do segurado.' }];

export const alertaPesquisarDadosBeneficio = [{ descricao: 'Obrigatório clicar no botão "Pesquisar Benefício" para atualizar os dados do benefício.' }];

export const msgsConfirmacaoIndeferimento = {
  indeferimento: {
    descricao: 'ATENÇÃO! Após confirmado o indeferimento, a ação será IRREVERSÍVEL!',
  },
  reaberturaIndeferimento: {
    descricao: 'Confirma a reabertura do requerimento?',
  },
};

export const msgsConfirmacaoExclusaoDocumentoRequerimento = {
  exclusao: {
    descricao: 'Confirma a exclusão do documento?',
  },
};

export const msgsCalculadorConversorNumeroNegativo = {
  aviso: {
    descricao: 'Impossível calcular, resulta número negativo!',
  },
};

export const msgSubmeterReprocessamentoGet = {
  descricao: 'Deseja realmente reprocessar o requerimento no GET ?',
};

export const msgConfirmacaoRequerimentosPeriodos = {
  descricao: 'Foram encontrados períodos para a ctc informada, deseja substituir os períodos do requerimento pelos períodos constantes na CTC ?',
};

export const msgConfirmacaoRequerimentosPeriodosConcomitancia = {
  descricao: 'Foram encontrados períodos concomitantes. Salvar mesmo assim ? Se salvar o Requerimento será gravado com o estado EM CONFLITO DE PERIODO',
};

export const msgCtcNaoEncontrada = {
  descricao: 'A CTC para este CPF não foi encontrada. Recomenda-se a anexação do documento para fins de otimização na análise do requerimento.',
};

export const msgReqAprovadoSemDataIngresso = {
  descricao1: {
    texto1: 'Já existe requerimento de compensação de aposentadoria para este CPF no estado "deferido" ou "em compensação" ou "compensado" sem data de ingresso.',
  },
  descricao2: {
    texto2: 'Favor verificar para evitar possível concomitância de períodos.',
  },
};

export const msgConfirmacaoCtc = {
  apagarRascunhoCtc: {
    descricao: 'Deseja realmente apagar o rascunho da CTC ?',
  },
  invalidarCtc: {
    descricao: 'Deseja realmente invalidar a CTC ?',
  },
  preencherValoresAutomaticamente: {
    descricao: 'Esta ação preencherá automaticamente os valores das remunerações referentes ao período exibido na aba. Deseja continuar ?',
  },
  periodoPossuiAlteracaoDeMoeda: {
    descricao: 'Existe uma competência com o valor diferente das demais. Deseja continuar ?',
  },
  limparValoresAutomaticamente: {
    descricao: 'Esta ação apagará automaticamente os valores das remunerações referentes ao período exibido na aba. Deseja continuar ?',
  },
};

export const msgRecalcularTempoRO = {
  descricaoComPeriodos: {
    descricao: 'Ao desmarcar o indicador de alteração manual do tempo RO, o sistema irá recalcular o tempo RO com base nos períodos informados na tela. Deseja prosseguir?',
  },
  descricaoSemPeriodos: {
    descricao: 'Ao desmarcar o indicador de alteração manual do tempo RO, o sistema irá retornar ao tempo de contribuição no regime de origem original. Deseja prosseguir?',
  },
};
// NÃO ESTÁ SENDO UTILIZADO
export const mensagensCtc = {
  ctcLimiteAtingidoParaCpf: {
    descricao: 'Não é possível adicionar nova CTC. Limite de CTC para este CPF foi atingido.',
  },
  ctcNaoEPossivelCriarComRascunho: {
    descricao: 'Não é possível adicionar nova CTC enquanto o rascunho não for salvo em definitivo.',
  },
  ctcRascunhoApagadoComSucesso: {
    descricao: 'Rascunho da CTC apagado com sucesso.',
  },
  ctcNaoEPossivelExcluirRascunho: {
    descricao: 'Não foi possível excluir o rascunho da CTC.',
  },
  ctcInvalidadaComSucesso: {
    descricao: 'CTC invalidada com sucesso.',
  },
  ctcNaoEPossivelInvalidar: {
    descricao: 'Não foi possível invalidar a CTC.',
  },
  ctcSemFiltroParaConsultarCpf: {
    descricao: 'Escolha pelo menos um filtro de CPF para a consulta.',
  },
  ctcNaoFoiPossivelExecutarAConsulta: {
    descricao: 'Não foi possível realizar a consulta.',
  },
  ctcContateOAdminDoSistema: {
    descricao: 'Contate o administrador do sistema.',
  },
  ctcRascunhoInseridoComSucesso: {
    descricao: 'Rascunho da CTC inserido com sucesso.',
  },
  ctcRascunhoAlteradoComSucesso: {
    descricao: 'Rascunho da CTC alterado com sucesso.',
  },
  ctcRevisadaComSucesso: {
    descricao: 'CTC revisada com sucesso.',
  },
  ctcInseridaComSucesso: {
    descricao: 'CTC inserida com sucesso.',
  },
  ctcInformeCorretamenteOsAtributosIndicadosNaTela: {
    descricao: 'Informe corretamente os atributos indicados na tela.',
  },
  ctcInformeCNPJValido: {
    descricao: 'CNPJ Inválido. Informe um CNPJ válido.',
  },
  ctcPeriodoDataInicioMaiorQueDataFim: {
    descricao: 'O período é inválido. A data de início de período deve ser menor que a data de fim do período.',
  },
  ctcPeriodoNaoMaiorQueDataAtual: {
    descricao: 'O período é inválido. A data de fim de período não deve ser maior que a data atual.',
  },
  ctcAtividadeSemDestinatario: {
    descricao: 'É necessário possuir pelo menos um destinatário cadastrado para incluir uma atividade.',
  },
  ctcQtdDiasLiquidoMaiorQueZero: {
    descricao: 'O período é inválido. A quantidade de dias liquido deve ser maior que zero e menor que diferença entre a data de inicio e fim periodo.',
  },
  ctcPeriodoAtividadeAlteradoComSucesso: {
    descricao: 'Período da atividade alterado com sucesso.',
  },
  ctcPeriodoAtividadeNaoPreenchido: {
    descricao: 'É necessário preencher a data de início e a data de fim da atividade na aba "Dados Básicos"',
  },
  ctcPreenchimentoTempoLiquidoObrigatorio: {
    descricao: 'Prenchimento do tempo líquido é obrigatório.',
  },
};

export const msgConflitosPeriodos = {
  reconhecimentoRequerimentoDeferidoComConflito: {
    descricao: 'Reconheço que este requerimento está sendo deferido com conflito e atesto que os períodos estão corretos',
  },
};



// WEBPACK FOOTER //
// ./src/utils/constants.js